// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-blend-mode: overlay;
  background-repeat: repeat, no-repeat;
  background-size: auto, cover;
  background-position: center, center;
  position: relative;
  overflow: hidden;
}

.login-form {
  background: #ffffff;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}

.login-logo {
  text-align: center;
  margin-bottom: 32px;
}

.login-logo img {
  height: 60px;
  width: auto;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #333333;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #1f2937;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.form-group input::placeholder {
  color: #9ca3af;
}

.form-group input:focus {
  border-color: #4C1CD2;
  box-shadow: 0 0 0 3px rgba(76, 28, 210, 0.1);
}

.btn-submit {
  width: 100%;
  padding: 14px;
  background: #4C1CD2;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.btn-submit:hover {
  background: #3d17a8;
}

.btn-submit:active {
  transform: scale(0.98);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  color: #dc2626;
  font-size: 14px;
  margin-top: 8px;
  padding: 8px 12px;
  background: #fee2e2;
  border-radius: 6px;
  border-left: 3px solid #dc2626;
}`, "",{"version":3,"sources":["webpack://./src/components/Auth/LoginForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-blend-mode: overlay;\n  background-repeat: repeat, no-repeat;\n  background-size: auto, cover;\n  background-position: center, center;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-form {\n  background: #ffffff;\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1;\n}\n\n.login-logo {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.login-logo img {\n  height: 60px;\n  width: auto;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  color: #333333;\n  font-size: 14px;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 16px;\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  color: #1f2937;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.form-group input::placeholder {\n  color: #9ca3af;\n}\n\n.form-group input:focus {\n  border-color: #4C1CD2;\n  box-shadow: 0 0 0 3px rgba(76, 28, 210, 0.1);\n}\n\n.btn-submit {\n  width: 100%;\n  padding: 14px;\n  background: #4C1CD2;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.btn-submit:hover {\n  background: #3d17a8;\n}\n\n.btn-submit:active {\n  transform: scale(0.98);\n}\n\n.btn-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.error-message {\n  color: #dc2626;\n  font-size: 14px;\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #fee2e2;\n  border-radius: 6px;\n  border-left: 3px solid #dc2626;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
